<div [@fadeLeft]="animationState" (@fadeLeft.done)="onFadeFinished($event)" class="w-3/4 absolute left-0 inset-y-0">
  <ng-container *ngTemplateOutlet="data.template"></ng-container>
</div>